import React from "react";
import StoreImages from "./../../../assets/background_banners.webp";
import title_banner_img from "./../../../assets/title_banner_img.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useTranslation } from "react-i18next";
import { getWindowDimensions } from "./CategorycardPage";

function BannercartPage (props) {
  const {width} = getWindowDimensions()
   const { t } = useTranslation();
   return (
       <div className="banner_cart">
       <LazyLoadImage alt="" className="banner_image" src={width > 600 ? StoreImages : title_banner_img}></LazyLoadImage>
       <div className="banner_title">
         <h5>{t(props?.title)}</h5>
       </div>
     </div>
   )
}
export default BannercartPage;